'use client';
import React from 'react';
import Link from 'next/link';
import '../globals.css';
import { Sidebar } from '../../components/Sidebar';
import { Sheet, SheetContent, SheetTrigger } from '../../components/ui/sheet';
import KalshiLogo from '@/components/DesignSystem/Icons/adhoc/KalshiLogo';
import MenuIcon from 'DesignSystem2/Icon/material/Menu';
import SizedIcon from 'DesignSystem2/Icon/SizedIcon';

export default function WidgetsLayout({ children }: { children: React.ReactNode }) {
    const [collapsed, setCollapsed] = React.useState(false);

    return (
        <div className="flex min-h-screen bg-surface-x10 text-text-x10">
            <Sidebar collapsed={collapsed} onToggle={() => setCollapsed(!collapsed)} />
            <div className="flex min-w-0 flex-1 flex-col">
                <header className="sticky top-0 z-20 border-b border-stroke-x40 bg-surface-x10/85 backdrop-blur supports-[backdrop-filter]:bg-surface-x10/70">
                    <div className="flex h-[72px] items-center gap-3 px-6 wsm:px-8">
                        <Link href="/" className="flex items-baseline gap-3 transition-opacity hover:opacity-70">
                            <KalshiLogo color="currentColor" height="22px" />
                            <span className="font-kalshi-sans text-[29px] font-light leading-none tracking-[0.1px] text-[#4d4d4d]">
                                Widgets
                            </span>
                        </Link>
                        <div className="ml-auto wsm:hidden">
                            <Sheet>
                                <SheetTrigger
                                    aria-label="Open navigation"
                                    className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-stroke-x30"
                                >
                                    <SizedIcon icon={MenuIcon} className="h-4 w-4" />
                                </SheetTrigger>
                                <SheetContent side="left">
                                    <div className="mb-4 flex items-baseline gap-3">
                                        <KalshiLogo color="currentColor" height="22px" />
                                        <span className="font-kalshi-sans text-[29px] font-light leading-none tracking-[0.1px] text-[#4d4d4d]">
                                            Widgets
                                        </span>
                                    </div>
                                    <Link
                                        href="/widgets"
                                        className="typ-body-x20 text-green-x10 underline-offset-4 hover:underline"
                                    >
                                        Browse widgets
                                    </Link>
                                </SheetContent>
                            </Sheet>
                        </div>
                    </div>
                </header>
                <main className="mx-auto w-full max-w-6xl px-6 py-10 wsm:px-8 wsm:py-14">{children}</main>
            </div>
        </div>
    );
}
